"use strict";

exports.__esModule = true;
exports["default"] = Chevron;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Chevron(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.645 15.928L7.596 3.895A2.244 2.244 0 1 1 10.772.722l13.614 13.6c.189.205.362.446.472.728.12.268.18.555.18.854a2.2 2.2 0 0 1-.18.872c-.11.27-.282.514-.472.724L10.699 31.172a2.209 2.209 0 0 1-1.588.669 2.182 2.182 0 0 1-1.588-.669 2.244 2.244 0 0 1 0-3.173l12.122-12.071z"
  }));
}